module.exports = __webpack_public_path__ + "images/emoji/facepalm.9b5c2f2e98fe25625725.png";